import { render, staticRenderFns } from "./ads.vue?vue&type=template&id=64cd9594&scoped=true&"
import script from "./ads.vue?vue&type=script&lang=js&"
export * from "./ads.vue?vue&type=script&lang=js&"
import style0 from "./ads.vue?vue&type=style&index=0&id=64cd9594&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd9594",
  null
  
)

export default component.exports